module.exports = __webpack_public_path__ + "frontend/images/miles/screen-payments-9927e4ed543326815af721cb2cc989e3.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/miles/screen-payments.png
// module id = 325
// module chunks = 2